import React from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Card, Link, Row, Stack, Title } from 'library/ui';
import { PAYMENT_FAQS } from './paymentFaqs';
import PaymentFaqList from './PaymentFaqList';

const INITIAL_COUNT = 3;

export default function PaymentFaq() {
    return (
        <Card padding="lg" fullHeight>
            <Stack gap="md">
                <Row justify="between" align="center">
                    <Title size="h2">Payment FAQs</Title>
                    {PAYMENT_FAQS.length > INITIAL_COUNT && (
                        <Link to="/payments/faqs">
                            View all <ArrowForward sx={{ fontSize: 16 }} />
                        </Link>
                    )}
                </Row>
                <PaymentFaqList faqs={PAYMENT_FAQS.slice(0, INITIAL_COUNT)} />
            </Stack>
        </Card>
    );
}
